import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Constants } from '../shared/constants';
import { Utils } from '../shared/utils';

@Injectable()
export class ClaimAccountService {

  constructor(private http: HttpClient) { }

  // call API passing new password along with confirm password to request to send reset it
  post(credentials: object) {
    const endpoint = Utils.getApiUrl() + Constants.LOGIN_SERVICES_API + Constants.API_VERSION +
      Constants.ACCOUNT_DOMAIN + Constants.CLAIM_ACCOUNT_URI;
    return this.http
      .post(endpoint, credentials).map((response: HttpResponse<any>) => response);
  }

}
